import React from "react"
import Moment from "moment"
import Consts from "../app/consts"
import { store } from "../app/store"
import TableConsts from "../common/components/table/tableConsts"
import { isNullOrUndefined } from "../utils/funcUtils"
import ArticleDetailsCell from "./components/articlesDetailsCell"
import { getLangNameFromCode } from "language-name-map"
import Highlighter from "react-highlight-words"

let articlesTableConsts = {
  data_columns: {
    siteName: {
      title: "Site",
      fieldName: "site_code",
      rawValue: (article) => article.site_code,
      campaignCustomFormat: (article) => {
        if (article.site_code) {
          return article.site_code.toUpperCase()
        }
        return TableConsts.EMPTY_CELL
      },
      cellSize: "x-small",
    },
    posts: {
      title: "Posts",
      fieldName: "article_name",
      cellSize: "large",
      cssClasses: ["aligned-left", "spread-content"],
      rawValue: (article) => article.article_name,
      campaignCustomFormat: (article) => {
        return <ArticleDetailsCell article={article} />
      },
    },

    postsPageTitles: {
      title: "Page Titles",
      fieldName: "posts_page_titles",
      tooltip: "<div><strong>Page Titles</strong> List of the Article items title.</div>",
      cellSize: "large",
      cssClasses: ["aligned-left"],
      rawValue: (article) => article.posts_page_titles?.titles.join(", "),
      campaignCustomFormat: (article) => {
        if (!isNullOrUndefined(article.posts_page_titles?.titles) && Array.isArray(article.posts_page_titles.titles)) {
          let search_full_text = store.getState().articles.filters.get("ARTICLE_FULL_TEXT")
          let filterValue =
            search_full_text && search_full_text.includeFilters[0]
              ? search_full_text.includeFilters[0]["filterValue"]
              : []
          return (
            <div className="page-titles">
              <Highlighter
                searchWords={filterValue}
                autoEscape={true}
                textToHighlight={article.posts_page_titles.titles.join(", ")}
              />
            </div>
          )
        }
        return TableConsts.EMPTY_CELL
      },
    },

    language: {
      title: "Language",
      isDefaultField: false,
      fieldName: "lang",
      tooltip: "<div><strong>Article Language</strong> is the language the article is written in.</div>",
      rawValue: (article) => article.lang,
      campaignCustomFormat: (article) => {
        if (article.lang) {
          return getLangNameFromCode(article.lang)?.name
        }
        return TableConsts.EMPTY_CELL
      },
      cellSize: "small-medium",
    },

    syndication: {
      title: "Syndication",
      fieldName: "tags",
      tooltip: "<div><strong>Syndication</strong> will present if the campaign is Original or a Syndication.</div>",
      rawValue: (article) => (article.tags?.tags.includes("Syndicated") ? "Syndicated" : "Original"),
      campaignCustomFormat: (article) => {
        if (!isNullOrUndefined(article.tags?.tags) && Array.isArray(article.tags.tags)) {
          return article.tags.tags.includes("Syndicated") ? "Syndicated" : "Original"
        }
        return TableConsts.EMPTY_CELL
      },
      cellSize: "small-medium",
    },

    category: {
      title: "Category",
      fieldName: "catalog_category_name",
      tooltip: "<div><strong>Category</strong> is the category the article is related to.</div>",
      rawValue: (article) => article.category_display_name,
      campaignCustomFormat: (article) => {
        if (article.category_display_name) {
          return article.category_display_name
        }
        return TableConsts.EMPTY_CELL
      },
      cellSize: "medium",
    },

    publishDate: {
      title: "Publish Date",
      isDefaultField: false,
      fieldName: "publish_date",
      tooltip: "<div><strong>Publish Date</strong> is the date when article was publish</div>",
      comparable: false,
      rawValue: (article) =>
        article.publish_date ? Moment(article.publish_date, "YYYY-MM-DD HH:mm:ss:000000").toISOString() : null,
      campaignCustomFormat: (article) => {
        return article.publish_date
          ? Moment(article.publish_date, "YYYY-MM-DD 00:00:00:000000").format(Consts.CLIENT_SHORT_DATE_FORMAT)
          : TableConsts.EMPTY_CELL
      },
    },

    postStyle: {
      title: "Post Style",
      fieldName: "post_style",
      tooltip: "<div><strong>Post Style</strong> declares if the Article is built as a List or as a Story.</div>",
      rawValue: (article) => article.post_style,
      campaignCustomFormat: (article) => {
        if (article.post_style) {
          return article.post_style[0].toUpperCase() + article.post_style.slice(1)
        }
        return TableConsts.EMPTY_CELL
      },
      cellSize: "slimmer-small",
    },
    Pages: {
      title: "Number of Pages",
      fieldName: "pages",
      rawValue: (article) => article.pages,
      campaignCustomFormat: (article) => {
        if (article.pages) {
          return article.pages
        }
        return TableConsts.EMPTY_CELL
      },
      cssClasses: ["last-cell-header"],
      cellSize: "slimmer-small",
    },
  },
}

Object.freeze(articlesTableConsts)
export default articlesTableConsts
